module.exports = __webpack_public_path__ + "img/993E8135.2b7ffe2e.jpg";